import { render, staticRenderFns } from "./PluginListItem.vue?vue&type=template&id=3c4bcd9f&scoped=true"
import script from "./PluginListItem.vue?vue&type=script&lang=js"
export * from "./PluginListItem.vue?vue&type=script&lang=js"
import style0 from "./PluginListItem.vue?vue&type=style&index=0&id=3c4bcd9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bcd9f",
  null
  
)

export default component.exports